export const statusEnvioDocumentoSeiEnum = Object.freeze({
    ENVIADO: 'ENVIADO',
    ERRO: 'ERRO'
})

function obterMensagemErro(erro) {
    if (!erro) return 'Erro desconhecido no envio'

    if (erro.message) return erro.message

    if (erro.response && erro.response.data) {
        const data = erro.response.data

        if (Array.isArray(data.errors) && data.errors.length > 0) {
            return data.errors.join('; ')
        }

        if (typeof data.message === 'string' && data.message.trim()) {
            return data.message
        }
    }

    return 'Erro desconhecido no envio'
}

function clonarItens(itens) {
    return itens.map(item => ({ ...item }))
}

export async function enviarDocumentosSeiLoteComRetry({
    anexos = [],
    parametros = {},
    enviarDocumento,
    onAtualizacao = () => { },
    maxTentativas = 2
}) {
    if (typeof enviarDocumento !== 'function') {
        throw new Error('A função enviarDocumento é obrigatória')
    }

    const itens = anexos.map((anexo, indice) => ({
        ...anexo,
        indice,
        statusEnvio: '',
        mensagemEnvio: '',
        resposta: null
    }))

    const totalTentativas = Math.max(1, maxTentativas)
    onAtualizacao(clonarItens(itens))

    for (const item of itens) {
        let ultimoErro = null

        for (let tentativa = 1; tentativa <= totalTentativas; tentativa++) {
            try {
                const resposta = await enviarDocumento({
                    anexo: item,
                    parametros,
                    tentativa,
                    indice: item.indice
                })

                const sucesso = resposta && resposta.success !== false
                if (!sucesso) {
                    const mensagem = resposta && Array.isArray(resposta.errors) && resposta.errors.length > 0
                        ? resposta.errors.join('; ')
                        : (resposta && resposta.message) || 'Falha ao enviar documento'
                    throw new Error(mensagem)
                }

                item.statusEnvio = statusEnvioDocumentoSeiEnum.ENVIADO
                item.mensagemEnvio = 'Enviado com sucesso'
                item.resposta = resposta
                ultimoErro = null
                break
            } catch (erro) {
                ultimoErro = erro
            }
        }

        if (ultimoErro) {
            item.statusEnvio = statusEnvioDocumentoSeiEnum.ERRO
            item.mensagemEnvio = obterMensagemErro(ultimoErro)
        }

        onAtualizacao(clonarItens(itens))
    }

    const enviados = itens.filter(item => item.statusEnvio === statusEnvioDocumentoSeiEnum.ENVIADO)
    const erros = itens.filter(item => item.statusEnvio === statusEnvioDocumentoSeiEnum.ERRO)

    return {
        itens: clonarItens(itens),
        total: itens.length,
        enviados: enviados.length,
        erros: erros.length,
        sucesso: erros.length === 0
    }
}
